<template>
  <nav>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <template
        v-if="canChangePassword"
        v-slot:activator="{ on, attrs }"
      >
        <v-btn
          data-testid="edit-password-button"
          v-bind="attrs"
          icon
          absolute
          right
          top
          class="mt-n2 mr-n2"
          v-on="on"
          @click="$emit('proceedSubmit', '', '')"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card data-testid="edit-user-card">
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="updatePassword"
          @submit.prevent
        >
          <v-toolbar
            dark
            color="accent"
          >
            <v-btn
              data-testid="close-button"
              icon
              dark
              @click="reloadForm"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="text-h5 font-weight-bold">
              {{ $t('editUserPasswordTitle') }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              data-testid="submit-button"
              type="submit"
              :disabled="loading"
              color="white"
              class="text-body-1 darktext--text text-none rounded-xxl px-4"
              @click="updatePassword"
            >
              {{ $t('save') }}
            </v-btn>
          </v-toolbar>
          <AlertMessages
            v-if="alertValue"
            alert-type="error" 
            :alert-msg="alertMsg"
            @reset="alertValue = false"
          />
          <v-card-text class="pt-0 pl-6">
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="py-15 px-md-12">
                  <v-text-field
                    v-model="currentPassword"
                    data-testid="password-current-input"
                    solo
                    hide-details="auto"
                    class="rounded-xxl text-body-2"
                    :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showCurrentPassword ? 'text' : 'password'"
                    :placeholder="$t('editUserCurrentPasswordPlaceholder')"
                    :rules="currentPasswordRules"
                    @click:append="showCurrentPassword = !showCurrentPassword"
                  />
                  <br>
                  <v-text-field
                    v-model="password"
                    data-testid="password-input"
                    solo
                    hide-details="auto"
                    class="rounded-xxl text-body-2"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    :placeholder="$t('editUserNewPasswordPlaceholder')"
                    :rules="passwordRules"
                    @click:append="showPassword = !showPassword"
                  />
                  <v-text-field
                    v-model="confirmPassword"
                    data-testid="password-confirm-input"
                    solo
                    hide-details="auto"
                    class="rounded-xxl text-body-2"
                    :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPasswordConfirm ? 'text' : 'password'"
                    :placeholder="$t('editUserConfirmNewPasswordPlaceholder')"
                    :rules="passwordRules.concat(passwordConfirmationRule)"
                    @click:append="showPasswordConfirm = !showPasswordConfirm"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { updateUser } from '../../api/userApi'
import { ruleRequired, passwordRuleValid, passwordRuleCharactersValid } from '../../rules/formRules.js';
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        AlertMessages
    },
    data(){
        return{
            dialog: false,
            valid: true,
            showCurrentPassword: false,
            showPassword: false,
            showPasswordConfirm: false,
            currentPassword: '',
            password: '',
            confirmPassword: '',
            currentPasswordRules: ruleRequired('labelPassword'),
            passwordRules: ruleRequired('labelPassword').concat(passwordRuleCharactersValid, passwordRuleValid),
            alertMsg: '',
            alertValue:false,
            userId: window.$cookies.get('id'),
            canChangePassword: localStorage.user ? JSON.parse(localStorage.user).can_change_password : true,
            loading: false
         }
    },
    computed: {
        passwordConfirmationRule() {
            return () =>
                this.password === this.confirmPassword || i18n.t('fieldErrorMatch', {'field': i18n.t('labelPassword') })
        },
    },
    methods: {
        async updatePassword(){
            this.$refs.form.validate()
            if(this.valid){
                this.loading = true
                var alertType = ''
                var alertMsg = ''
                try {
                    let data = {
                        data: {
                            type: "users", 
                            id: this.userId,
                            attributes: {
                                password_current: this.currentPassword.trim(),
                                password: this.password.trim(),
                                password_confirmation: this.confirmPassword.trim()
                            }
                        }
                    };
                    const response = await updateUser(this.userId, data)
                    if(response.status == 200) {
                        alertMsg =  i18n.t('editUserSuccess')
                        alertType = 'success'
                        this.$emit('proceedSubmit', alertMsg, alertType)
                        this.reloadForm()
                    }
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if (e.response.status == 422 ){
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'The password current did not match!'){
                                    this.alertType = 'error'
                                    this.alertMsg = i18n.t('editUserErrorWrongCurrentPassword')
                                }else if(e.response.data.errors[i].detail == 'The password must contain at least one special character!'){
                                    this.alertType = 'error'
                                    this.alertMsg = i18n.t('resetPasswordInvalidCharacter')
                                }else{
                                    alertType = 'error'
                                    alertMsg =  i18n.t('serverError')
                                    this.$emit('proceedSubmit', alertMsg, alertType)
                                    this.reloadForm()
                                }
                            }
                        } else if (e.response.status == 403){
                            for (let i = 0; i < e.response.data.errors.length; i++) {
                                if (e.response.data.errors[i].detail == 'You must log in using SSO') {
                                    alertType = 'error'
                                    alertMsg = i18n.t('mustLogInUsingSSO')
                                    this.$emit('proceedSubmit', alertMsg, alertType)
                                    this.reloadForm()
                                }
                            }
                        }  else {
                            alertType = 'error'
                            alertMsg =  i18n.t('serverError')
                            this.$emit('proceedSubmit', alertMsg, alertType)
                            this.reloadForm()
                        }
                    }
                }
                this.loading = false
            }
        },
        reloadForm(){
            this.showCurrentPassword = false
            this.showPassword = false
            this.showPasswordConfirm = false
            this.dialog = false
            this.alertMsg = ''
            this.alertValue = false
            this.$refs.form.reset()
            
        }
    }
}
</script>